import { Component, Input, OnInit } from '@angular/core';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { AdminService, AuthService } from '../../../services';
import { User } from '../../../models';

@Component({
    selector: 'sn-usc-doc-nav',
    templateUrl: './usc-doc-nav.component.html',
    styleUrls: ['./usc-doc-nav.component.css']
})
export class UscDocNavComponent implements OnInit {
    @Input() view: string;

    currentViewClass: any = {
        view_usc_store_visit_checkin: "nav-item",
        view_usc_store_visit_waiting_appt: "nav-item",
        view_usc_store_visit_scheduled_appt: "nav-item",
        view_usc_store_visit_serving_now: "nav-item",
        view_usc_store_visit_service_completed: "nav-item",
        view_usc_store_scheduling_setup: "nav-item",
    }

    public is_available_stores_loaded:boolean = false;
    public available_stores:User[] = [];
    public current_store:User;
    
    constructor(
        public uscStoreService: UscStoreService,
        private authService: AuthService,
        private adminService: AdminService,
    ) { }

    ngOnInit() {
        // for (var p in this.currentViewClass) {
        //     this.currentViewClass[p] = "nav-item";
        //     if (p == this.view) {
        //         this.currentViewClass[p] = "nav-item active";
        //     }
        // }

        // if (this.uscStoreService.isLeader()) {
        //     this.current_store = this.uscStoreService.getCurrentStoreVisitStore();
        //     this.available_stores = this.uscStoreService.getSvtStoreUserByScope();
        //     if (this.available_stores) {
        //         this.is_available_stores_loaded = (this.available_stores.length > 0);
        //         if (this.current_store == null) this.uscStoreService.setSvtCurrentStore(this.available_stores[0]);
        //     }
        // }

        // this.uscStoreService.svtCurrentStore.subscribe(store => {
        //     this.current_store = store;
        // })
    }

    navigate(selection) {
        this.uscStoreService.setCurrentView(selection);
    }

    showStoreList() {
        return this.is_available_stores_loaded && this.uscStoreService.enabledStoreVisitLeaderView();
    }

    showCheckInTab() {
        return this.uscStoreService.isUSCellAgent() || (this.uscStoreService.isUSCellCorp() && !this.uscStoreService.isLeader() || this.uscStoreService.isStoreMgrOrAssistant());
    }

    showSchedulingSetupTab() {
        return this.uscStoreService.isLeader();
    }

    setStoreFilter(store) {
        this.current_store = store;
        this.uscStoreService.setSvtCurrentStore(store);
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-doc-nav/usc-doc-nav.component.ts